// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VisitsDueView-module__root___CS23J {
  display: block;
}

.VisitsDueView-module__toolbar___UkACy {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 0;
  margin-bottom: 8px;
}

.VisitsDueView-module__readout___sXbXA {
  margin-left: auto;
  font-size: 13px;
  color: #71717a;
}

.VisitsDueView-module__statsRow___G2L_N {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
  margin-bottom: 16px;
}

.VisitsDueView-module__statCard___GcBeg {
  background: #ffffff;
  border: 1px solid #e4e4e7;
  border-radius: 8px;
  padding: 10px 13px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.VisitsDueView-module__statLabel___VSbgL {
  font-size: 13px;
  line-height: 1.4286;
  color: #71717a;
  font-weight: 500;
  margin-bottom: 2px;
}

.VisitsDueView-module__statValue___FPdaP {
  display: block;
  font-size: 30px;
  line-height: 1;
  font-weight: 700;
  font-family: "IBM Plex Mono", monospace;
  color: #18181b;
}

.VisitsDueView-module__statValuegreen___bmWv5 {
  color: #166534;
}

.VisitsDueView-module__statValueyellow___S6Mhk {
  color: #854d0e;
}

.VisitsDueView-module__statValuered___jNXu2 {
  color: #991b1b;
}

.VisitsDueView-module__emptyState___Yd2BH {
  margin-top: 12px;
  padding: 24px;
  text-align: center;
  font-size: 14px;
  color: #71717a;
  background: #ffffff;
  border: 1px solid #e4e4e7;
  border-radius: 8px;
}

.VisitsDueView-module__layoutGrid___TkOs3 {
  display: grid;
  grid-template-columns: minmax(0, 2fr) minmax(340px, 1fr);
  gap: 16px;
  align-items: start;
  margin-top: 12px;
}

.VisitsDueView-module__listColumn___fG77i {
  min-width: 0;
}

.VisitsDueView-module__railColumn___G1RWB {
  position: sticky;
  top: 16px;
  max-height: calc(100vh - var(--tabs-navigation) - var(--secondary-navigation) - var(--patient-details-footer) - 54px);
  overflow-y: auto;
  scrollbar-width: none;
  padding-bottom: 80px;
}

.VisitsDueView-module__railColumn___G1RWB::-webkit-scrollbar {
  width: 0;
  height: 0;
}

.VisitsDueView-module__loaderWrap___YJWxU {
  display: flex;
  justify-content: center;
  padding: 24px 0;
}

.VisitsDueView-module__railEmpty___uWdPi {
  padding: 24px;
  text-align: center;
  font-size: 13px;
  color: #71717a;
  background: #ffffff;
  border: 1px solid #dcdce0;
  border-radius: 8px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.VisitsDueView-module__chipsRow___WQdEv {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  margin-bottom: 8px;
}

.VisitsDueView-module__chip___Hb7Y7 {
  padding: 2px 10px;
  border-radius: 999px;
  border: 1px solid #e4e4e7;
  background: #ffffff;
  color: #52525b;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: border-color 0.15s ease;
}
.VisitsDueView-module__chip___Hb7Y7:hover {
  border-color: #a1a1aa;
}

.VisitsDueView-module__chipOn___ZW4BY {
  border-color: #18181b;
  background: #18181b;
  color: #fafafa;
}

.VisitsDueView-module__chipMono___PUibh {
  font-family: "IBM Plex Mono", monospace;
}

.VisitsDueView-module__chipDivider___vOUNB {
  width: 1px;
  height: 16px;
  background: #e4e4e7;
  margin: 0 4px;
}

.VisitsDueView-module__layoutToggle___fMdpf {
  display: flex;
  gap: 2px;
  margin-left: auto;
  padding: 2px;
  background: #f4f4f5;
  border-radius: 6px;
}

.VisitsDueView-module__layoutButton___CvXiB {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 4px 10px;
  font-size: 13px;
  font-weight: 500;
  border-radius: 4px;
  border: none;
  background: transparent;
  color: #71717a;
  cursor: pointer;
}
.VisitsDueView-module__layoutButton___CvXiB:hover {
  color: #18181b;
}

.VisitsDueView-module__layoutButtonOn___NrvAK {
  background: #ffffff;
  color: #18181b;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.VisitsDueView-module__listCard____5q29 {
  background: #ffffff;
  border: 1px solid #e4e4e7;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.VisitsDueView-module__columns___nneXe {
  display: grid;
  grid-template-columns: minmax(120px, 1fr) 248px 92px minmax(0, 1fr) minmax(0, 1.1fr);
  align-items: center;
  gap: 10px;
  min-width: 0;
}

.VisitsDueView-module__listHeader___xHQvR {
  display: flex;
  align-items: center;
  border-bottom: 1px solid #e4e4e7;
}

.VisitsDueView-module__headerColumns___s1W6K {
  flex: 1;
  padding: 6px 0 6px 13px;
}

.VisitsDueView-module__openHeader___nzASt {
  width: 64px;
  flex-shrink: 0;
  padding-right: 13px;
  text-align: right;
}

.VisitsDueView-module__groupBand___X145b {
  padding-left: 13px;
  padding-right: 13px;
}

.VisitsDueView-module__listRow___kTFFH {
  display: flex;
  align-items: center;
  background: #ffffff;
  border-bottom: 1px solid #f4f4f5;
  transition: background-color 0.15s;
}
.VisitsDueView-module__listRow___kTFFH:last-child {
  border-bottom: none;
}
.VisitsDueView-module__listRow___kTFFH:hover {
  background: #fafafa;
}

.VisitsDueView-module__listRowOn___Qcg6P {
  background: #fafafa;
  box-shadow: inset 2px 0 0 #18181b;
}

.VisitsDueView-module__rowButton___QiF2E {
  flex: 1;
  padding: 6px 0 6px 13px;
  border: 0;
  background: transparent;
  text-align: left;
  font: inherit;
  line-height: 1.5;
  cursor: pointer;
}
.VisitsDueView-module__rowButton___QiF2E:focus-visible {
  outline: 2px solid #a1a1aa;
  outline-offset: -2px;
}

.VisitsDueView-module__cellName___IZ_8A {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 15px;
  line-height: 1.5;
  font-weight: 500;
  color: #18181b;
}

.VisitsDueView-module__cellStatus___InlEm {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 4px;
  overflow: hidden;
}

.VisitsDueView-module__cellMono___pO92Z {
  white-space: nowrap;
  font-family: "IBM Plex Mono", monospace;
  font-size: 13px;
  line-height: 1.4286;
  color: #3f3f46;
}

.VisitsDueView-module__cellAnchor___XMpv_,
.VisitsDueView-module__cellMeta___Mh53U {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 13px;
  line-height: 1.4286;
}

.VisitsDueView-module__cellAnchor___XMpv_ {
  color: #52525b;
}

.VisitsDueView-module__cellMeta___Mh53U {
  color: #71717a;
}

.VisitsDueView-module__rowLinks___qarO6 {
  width: 64px;
  flex-shrink: 0;
  padding-right: 13px;
}

.VisitsDueView-module__pills___aXv2q {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}

.VisitsDueView-module__openButtons___C15gF {
  display: flex;
  justify-content: flex-end;
  gap: 4px;
}

.VisitsDueView-module__openButton___guxz4 {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  padding: 0;
  border: none;
  border-radius: 4px;
  background: #18181b;
  color: #fafafa;
  font-size: 11px;
  font-weight: 600;
  text-decoration: none;
  cursor: pointer;
}
.VisitsDueView-module__openButton___guxz4[aria-disabled=true] {
  opacity: 0.35;
  cursor: not-allowed;
}

.VisitsDueView-module__cardsWrap___AYRHo {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.VisitsDueView-module__gapCard___zSkVG {
  display: flex;
  width: 100%;
  align-items: flex-start;
  gap: 12px;
  padding: 10px 16px;
  border: 0;
  border-bottom: 1px solid #f4f4f5;
  background: #ffffff;
  text-align: left;
  font: inherit;
  cursor: pointer;
}
.VisitsDueView-module__gapCard___zSkVG:last-child {
  border-bottom: none;
}
.VisitsDueView-module__gapCard___zSkVG:hover {
  background: #fafafa;
}
.VisitsDueView-module__gapCard___zSkVG:focus-visible {
  outline: 2px solid #a1a1aa;
  outline-offset: -2px;
}

.VisitsDueView-module__gapCardOn___eOY4p {
  background: #fafafa;
}

.VisitsDueView-module__gapCardMain___TJFlb {
  display: flex;
  min-width: 0;
  flex: 1;
  flex-direction: column;
}

.VisitsDueView-module__rowName___eCmhX {
  font-size: 15px;
  line-height: 1.5;
  font-weight: 600;
  color: #18181b;
}

.VisitsDueView-module__gapCardTitle___HQJzl {
  margin-top: 4px;
  font-size: 15px;
  line-height: 1.5;
  font-weight: 500;
  color: #18181b;
}

.VisitsDueView-module__gapCardEvidence___RIh2d {
  margin-top: 8px;
  padding-left: 10px;
  border-left: 2px solid #e4e4e7;
  font-size: 13px;
  line-height: 1.4286;
  color: #71717a;
}

.VisitsDueView-module__rowMeta___nphBk {
  margin-top: 8px;
  font-size: 12px;
  line-height: 1.4286;
  color: #71717a;
}

.VisitsDueView-module__gapCardSide___wMVTB {
  display: flex;
  max-width: 45%;
  flex-shrink: 0;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 4px;
}`, "",{"version":3,"sources":["webpack://./src/pages/CareOrchestration/components/VisitsDueView/VisitsDueView.module.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,kBAAA;AACF;;AAEA;EACE,iBAAA;EACA,eAAA;EACA,cAAA;AACF;;AAEA;EACE,aAAA;EACA,qCAAA;EACA,SAAA;EACA,mBAAA;AACF;;AAEA;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,yCAAA;AACF;;AAEA;EACE,eAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;AACF;;AAEA;EACE,cAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,uCAAA;EACA,cAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,gBAAA;EACA,aAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;AACF;;AAEA;EACE,aAAA;EACA,wDAAA;EACA,SAAA;EACA,kBAAA;EACA,gBAAA;AACF;;AAEA;EACE,YAAA;AACF;;AAEA;EACE,gBAAA;EACA,SAAA;EACA,qHAAA;EAIA,gBAAA;EACA,qBAAA;EACA,oBAAA;AAFF;;AAKA;EACE,QAAA;EACA,SAAA;AAFF;;AAKA;EACE,aAAA;EACA,uBAAA;EACA,eAAA;AAFF;;AAKA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,yCAAA;AAFF;;AAKA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;AAFF;;AAKA;EACE,iBAAA;EACA,oBAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,mCAAA;AAFF;AAIE;EACE,qBAAA;AAFJ;;AAMA;EACE,qBAAA;EACA,mBAAA;EACA,cAAA;AAHF;;AAMA;EACE,uCAAA;AAHF;;AAMA;EACE,UAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;AAHF;;AAMA;EACE,aAAA;EACA,QAAA;EACA,iBAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;AAHF;;AAMA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;AAHF;AAKE;EACE,cAAA;AAHJ;;AAOA;EACE,mBAAA;EACA,cAAA;EACA,yCAAA;AAJF;;AAOA;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yCAAA;AAJF;;AAOA;EACE,aAAA;EACA,oFAAA;EACA,mBAAA;EACA,SAAA;EACA,YAAA;AAJF;;AAOA;EACE,aAAA;EACA,mBAAA;EACA,gCAAA;AAJF;;AAOA;EACE,OAAA;EACA,uBAAA;AAJF;;AAOA;EACE,WAAA;EACA,cAAA;EACA,mBAAA;EACA,iBAAA;AAJF;;AAOA;EACE,kBAAA;EACA,mBAAA;AAJF;;AAOA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,gCAAA;EACA,kCAAA;AAJF;AAME;EACE,mBAAA;AAJJ;AAOE;EACE,mBAAA;AALJ;;AASA;EACE,mBAAA;EACA,iCAAA;AANF;;AASA;EACE,OAAA;EACA,uBAAA;EACA,SAAA;EACA,uBAAA;EACA,gBAAA;EACA,aAAA;EACA,gBAAA;EACA,eAAA;AANF;AAQE;EACE,0BAAA;EACA,oBAAA;AANJ;;AAUA;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;AAPF;;AAUA;EACE,aAAA;EACA,YAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;AAPF;;AAUA;EACE,mBAAA;EACA,uCAAA;EACA,eAAA;EACA,mBAAA;EACA,cAAA;AAPF;;AAUA;;EAEE,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;AAPF;;AAUA;EACE,cAAA;AAPF;;AAUA;EACE,cAAA;AAPF;;AAUA;EACE,WAAA;EACA,cAAA;EACA,mBAAA;AAPF;;AAUA;EACE,aAAA;EACA,eAAA;EACA,QAAA;AAPF;;AAUA;EACE,aAAA;EACA,yBAAA;EACA,QAAA;AAPF;;AAUA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,eAAA;AAPF;AASE;EACE,aAAA;EACA,mBAAA;AAPJ;;AAWA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AARF;;AAWA;EACE,aAAA;EACA,WAAA;EACA,uBAAA;EACA,SAAA;EACA,kBAAA;EACA,SAAA;EACA,gCAAA;EACA,mBAAA;EACA,gBAAA;EACA,aAAA;EACA,eAAA;AARF;AAUE;EACE,mBAAA;AARJ;AAWE;EACE,mBAAA;AATJ;AAYE;EACE,0BAAA;EACA,oBAAA;AAVJ;;AAcA;EACE,mBAAA;AAXF;;AAcA;EACE,aAAA;EACA,YAAA;EACA,OAAA;EACA,sBAAA;AAXF;;AAcA;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;AAXF;;AAcA;EACE,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;AAXF;;AAcA;EACE,eAAA;EACA,kBAAA;EACA,8BAAA;EACA,eAAA;EACA,mBAAA;EACA,cAAA;AAXF;;AAcA;EACE,eAAA;EACA,eAAA;EACA,mBAAA;EACA,cAAA;AAXF;;AAcA;EACE,aAAA;EACA,cAAA;EACA,cAAA;EACA,eAAA;EACA,yBAAA;EACA,QAAA;AAXF","sourcesContent":[".root {\n  display: block;\n}\n\n.toolbar {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 10px 0;\n  margin-bottom: 8px;\n}\n\n.readout {\n  margin-left: auto;\n  font-size: 13px;\n  color: #71717a;\n}\n\n.statsRow {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 12px;\n  margin-bottom: 16px;\n}\n\n.statCard {\n  background: #ffffff;\n  border: 1px solid #e4e4e7;\n  border-radius: 8px;\n  padding: 10px 13px;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n}\n\n.statLabel {\n  font-size: 13px;\n  line-height: 1.4286;\n  color: #71717a;\n  font-weight: 500;\n  margin-bottom: 2px;\n}\n\n.statValue {\n  display: block;\n  font-size: 30px;\n  line-height: 1;\n  font-weight: 700;\n  font-family: 'IBM Plex Mono', monospace;\n  color: #18181b;\n}\n\n.statValuegreen {\n  color: #166534;\n}\n\n.statValueyellow {\n  color: #854d0e;\n}\n\n.statValuered {\n  color: #991b1b;\n}\n\n.emptyState {\n  margin-top: 12px;\n  padding: 24px;\n  text-align: center;\n  font-size: 14px;\n  color: #71717a;\n  background: #ffffff;\n  border: 1px solid #e4e4e7;\n  border-radius: 8px;\n}\n\n.layoutGrid {\n  display: grid;\n  grid-template-columns: minmax(0, 2fr) minmax(340px, 1fr);\n  gap: 16px;\n  align-items: start;\n  margin-top: 12px;\n}\n\n.listColumn {\n  min-width: 0;\n}\n\n.railColumn {\n  position: sticky;\n  top: 16px;\n  max-height: calc(\n    100vh - var(--tabs-navigation) - var(--secondary-navigation) - var(--patient-details-footer) -\n      54px\n  );\n  overflow-y: auto;\n  scrollbar-width: none;\n  padding-bottom: 80px;\n}\n\n.railColumn::-webkit-scrollbar {\n  width: 0;\n  height: 0;\n}\n\n.loaderWrap {\n  display: flex;\n  justify-content: center;\n  padding: 24px 0;\n}\n\n.railEmpty {\n  padding: 24px;\n  text-align: center;\n  font-size: 13px;\n  color: #71717a;\n  background: #ffffff;\n  border: 1px solid #dcdce0;\n  border-radius: 8px;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n}\n\n.chipsRow {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 6px;\n  margin-bottom: 8px;\n}\n\n.chip {\n  padding: 2px 10px;\n  border-radius: 999px;\n  border: 1px solid #e4e4e7;\n  background: #ffffff;\n  color: #52525b;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: border-color 0.15s ease;\n\n  &:hover {\n    border-color: #a1a1aa;\n  }\n}\n\n.chipOn {\n  border-color: #18181b;\n  background: #18181b;\n  color: #fafafa;\n}\n\n.chipMono {\n  font-family: 'IBM Plex Mono', monospace;\n}\n\n.chipDivider {\n  width: 1px;\n  height: 16px;\n  background: #e4e4e7;\n  margin: 0 4px;\n}\n\n.layoutToggle {\n  display: flex;\n  gap: 2px;\n  margin-left: auto;\n  padding: 2px;\n  background: #f4f4f5;\n  border-radius: 6px;\n}\n\n.layoutButton {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  padding: 4px 10px;\n  font-size: 13px;\n  font-weight: 500;\n  border-radius: 4px;\n  border: none;\n  background: transparent;\n  color: #71717a;\n  cursor: pointer;\n\n  &:hover {\n    color: #18181b;\n  }\n}\n\n.layoutButtonOn {\n  background: #ffffff;\n  color: #18181b;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n}\n\n.listCard {\n  background: #ffffff;\n  border: 1px solid #e4e4e7;\n  border-radius: 8px;\n  overflow: hidden;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n}\n\n.columns {\n  display: grid;\n  grid-template-columns: minmax(120px, 1fr) 248px 92px minmax(0, 1fr) minmax(0, 1.1fr);\n  align-items: center;\n  gap: 10px;\n  min-width: 0;\n}\n\n.listHeader {\n  display: flex;\n  align-items: center;\n  border-bottom: 1px solid #e4e4e7;\n}\n\n.headerColumns {\n  flex: 1;\n  padding: 6px 0 6px 13px;\n}\n\n.openHeader {\n  width: 64px;\n  flex-shrink: 0;\n  padding-right: 13px;\n  text-align: right;\n}\n\n.groupBand {\n  padding-left: 13px;\n  padding-right: 13px;\n}\n\n.listRow {\n  display: flex;\n  align-items: center;\n  background: #ffffff;\n  border-bottom: 1px solid #f4f4f5;\n  transition: background-color 0.15s;\n\n  &:last-child {\n    border-bottom: none;\n  }\n\n  &:hover {\n    background: #fafafa;\n  }\n}\n\n.listRowOn {\n  background: #fafafa;\n  box-shadow: inset 2px 0 0 #18181b;\n}\n\n.rowButton {\n  flex: 1;\n  padding: 6px 0 6px 13px;\n  border: 0;\n  background: transparent;\n  text-align: left;\n  font: inherit;\n  line-height: 1.5;\n  cursor: pointer;\n\n  &:focus-visible {\n    outline: 2px solid #a1a1aa;\n    outline-offset: -2px;\n  }\n}\n\n.cellName {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-size: 15px;\n  line-height: 1.5;\n  font-weight: 500;\n  color: #18181b;\n}\n\n.cellStatus {\n  display: flex;\n  min-width: 0;\n  align-items: center;\n  gap: 4px;\n  overflow: hidden;\n}\n\n.cellMono {\n  white-space: nowrap;\n  font-family: 'IBM Plex Mono', monospace;\n  font-size: 13px;\n  line-height: 1.4286;\n  color: #3f3f46;\n}\n\n.cellAnchor,\n.cellMeta {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-size: 13px;\n  line-height: 1.4286;\n}\n\n.cellAnchor {\n  color: #52525b;\n}\n\n.cellMeta {\n  color: #71717a;\n}\n\n.rowLinks {\n  width: 64px;\n  flex-shrink: 0;\n  padding-right: 13px;\n}\n\n.pills {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n}\n\n.openButtons {\n  display: flex;\n  justify-content: flex-end;\n  gap: 4px;\n}\n\n.openButton {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 22px;\n  height: 22px;\n  padding: 0;\n  border: none;\n  border-radius: 4px;\n  background: #18181b;\n  color: #fafafa;\n  font-size: 11px;\n  font-weight: 600;\n  text-decoration: none;\n  cursor: pointer;\n\n  &[aria-disabled='true'] {\n    opacity: 0.35;\n    cursor: not-allowed;\n  }\n}\n\n.cardsWrap {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.gapCard {\n  display: flex;\n  width: 100%;\n  align-items: flex-start;\n  gap: 12px;\n  padding: 10px 16px;\n  border: 0;\n  border-bottom: 1px solid #f4f4f5;\n  background: #ffffff;\n  text-align: left;\n  font: inherit;\n  cursor: pointer;\n\n  &:last-child {\n    border-bottom: none;\n  }\n\n  &:hover {\n    background: #fafafa;\n  }\n\n  &:focus-visible {\n    outline: 2px solid #a1a1aa;\n    outline-offset: -2px;\n  }\n}\n\n.gapCardOn {\n  background: #fafafa;\n}\n\n.gapCardMain {\n  display: flex;\n  min-width: 0;\n  flex: 1;\n  flex-direction: column;\n}\n\n.rowName {\n  font-size: 15px;\n  line-height: 1.5;\n  font-weight: 600;\n  color: #18181b;\n}\n\n.gapCardTitle {\n  margin-top: 4px;\n  font-size: 15px;\n  line-height: 1.5;\n  font-weight: 500;\n  color: #18181b;\n}\n\n.gapCardEvidence {\n  margin-top: 8px;\n  padding-left: 10px;\n  border-left: 2px solid #e4e4e7;\n  font-size: 13px;\n  line-height: 1.4286;\n  color: #71717a;\n}\n\n.rowMeta {\n  margin-top: 8px;\n  font-size: 12px;\n  line-height: 1.4286;\n  color: #71717a;\n}\n\n.gapCardSide {\n  display: flex;\n  max-width: 45%;\n  flex-shrink: 0;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n  gap: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `VisitsDueView-module__root___CS23J`,
	"toolbar": `VisitsDueView-module__toolbar___UkACy`,
	"readout": `VisitsDueView-module__readout___sXbXA`,
	"statsRow": `VisitsDueView-module__statsRow___G2L_N`,
	"statCard": `VisitsDueView-module__statCard___GcBeg`,
	"statLabel": `VisitsDueView-module__statLabel___VSbgL`,
	"statValue": `VisitsDueView-module__statValue___FPdaP`,
	"statValuegreen": `VisitsDueView-module__statValuegreen___bmWv5`,
	"statValueyellow": `VisitsDueView-module__statValueyellow___S6Mhk`,
	"statValuered": `VisitsDueView-module__statValuered___jNXu2`,
	"emptyState": `VisitsDueView-module__emptyState___Yd2BH`,
	"layoutGrid": `VisitsDueView-module__layoutGrid___TkOs3`,
	"listColumn": `VisitsDueView-module__listColumn___fG77i`,
	"railColumn": `VisitsDueView-module__railColumn___G1RWB`,
	"loaderWrap": `VisitsDueView-module__loaderWrap___YJWxU`,
	"railEmpty": `VisitsDueView-module__railEmpty___uWdPi`,
	"chipsRow": `VisitsDueView-module__chipsRow___WQdEv`,
	"chip": `VisitsDueView-module__chip___Hb7Y7`,
	"chipOn": `VisitsDueView-module__chipOn___ZW4BY`,
	"chipMono": `VisitsDueView-module__chipMono___PUibh`,
	"chipDivider": `VisitsDueView-module__chipDivider___vOUNB`,
	"layoutToggle": `VisitsDueView-module__layoutToggle___fMdpf`,
	"layoutButton": `VisitsDueView-module__layoutButton___CvXiB`,
	"layoutButtonOn": `VisitsDueView-module__layoutButtonOn___NrvAK`,
	"listCard": `VisitsDueView-module__listCard____5q29`,
	"columns": `VisitsDueView-module__columns___nneXe`,
	"listHeader": `VisitsDueView-module__listHeader___xHQvR`,
	"headerColumns": `VisitsDueView-module__headerColumns___s1W6K`,
	"openHeader": `VisitsDueView-module__openHeader___nzASt`,
	"groupBand": `VisitsDueView-module__groupBand___X145b`,
	"listRow": `VisitsDueView-module__listRow___kTFFH`,
	"listRowOn": `VisitsDueView-module__listRowOn___Qcg6P`,
	"rowButton": `VisitsDueView-module__rowButton___QiF2E`,
	"cellName": `VisitsDueView-module__cellName___IZ_8A`,
	"cellStatus": `VisitsDueView-module__cellStatus___InlEm`,
	"cellMono": `VisitsDueView-module__cellMono___pO92Z`,
	"cellAnchor": `VisitsDueView-module__cellAnchor___XMpv_`,
	"cellMeta": `VisitsDueView-module__cellMeta___Mh53U`,
	"rowLinks": `VisitsDueView-module__rowLinks___qarO6`,
	"pills": `VisitsDueView-module__pills___aXv2q`,
	"openButtons": `VisitsDueView-module__openButtons___C15gF`,
	"openButton": `VisitsDueView-module__openButton___guxz4`,
	"cardsWrap": `VisitsDueView-module__cardsWrap___AYRHo`,
	"gapCard": `VisitsDueView-module__gapCard___zSkVG`,
	"gapCardOn": `VisitsDueView-module__gapCardOn___eOY4p`,
	"gapCardMain": `VisitsDueView-module__gapCardMain___TJFlb`,
	"rowName": `VisitsDueView-module__rowName___eCmhX`,
	"gapCardTitle": `VisitsDueView-module__gapCardTitle___HQJzl`,
	"gapCardEvidence": `VisitsDueView-module__gapCardEvidence___RIh2d`,
	"rowMeta": `VisitsDueView-module__rowMeta___nphBk`,
	"gapCardSide": `VisitsDueView-module__gapCardSide___wMVTB`
};
module.exports = ___CSS_LOADER_EXPORT___;
